import { styled } from '@mui/material/styles'
import { Box, Card, Typography } from '@mui/material'

export const Wrapper = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  borderTop: `4px solid ${theme.palette.secondary.main}`,
  borderRadius: '8px',
  boxShadow: 'rgba(0, 0, 0, 0.24) 0px 4px 4px',
  '&:hover': {
    boxShadow: 'rgba(0, 0, 0, 0.24) 0px 4px 4px',
  },
}))

export const DeleteIconStyle = styled('div')(({ theme }) => ({
  borderRadius: '8px',
  fontSize: 24,
  cursor: 'pointer',
  transition: 'transform 0.2s ease-in-out',
  '&:hover': {
    transform: 'scale(1.2)',
  },
}))

export const GoToIcon = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  alignItems: 'flex-end',
  cursor: 'pointer',
  fontSize: 24,
  marginRight: '10px',
  marginBottom: '2px',
  color: theme.palette.primary.main,
}))

export const ViewFont = styled(Typography)(() => ({
  fontSize: 16,
  fontWeight: 'normal',
  textDecoration: 'none',
  transition: 'font-weight text-decoration 0.2s ease-in-out',
  '&:hover': {
    fontWeight: 'bold',
    textDecoration: 'underline',
  },
}))

export const Content = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '24px 16px 16px 16px',
  minHeight: '230px',
  width: '450px',
}))

export const Title = styled('div')(() => ({
  textTransform: 'uppercase',
  letterSpacing: '0.8px',
  marginBottom: '16px',
  color: '#666',
}))

export const Bold = styled('span')(() => ({
  fontWeight: 600,
}))

export const Detail = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  padding: '8px 0px',
  marginTop: '16px',
}))

export const DetailIcon = styled(Box)(() => ({
  marginRight: '16px',
  color: '#999',
}))

export const DetailSnapshot = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
}))

export const SecondaryText = styled('span')(() => ({
  color: '#5D5D5D',
}))

export const Footer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  backgroundColor: '#c5e2ec21',
  padding: '24px 16px 16px 16px',
}))

export const FooterDetail = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
}))

export const FooterDetailIcon = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginRight: '4px',
  color: '#5D5D5D',
}))

export const FooterText = styled('span')(() => ({
  color: '#4B5563',
}))

export const Timestamp = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  paddingLeft: '16px',
  borderLeft: `2px solid ${theme.borders.grey}`,
}))

export const PublicPrivateIconContainer = styled(Box)(() => ({
  display: 'flex',
  width: '100%',
  justifyContent: 'flex-end',
}))
